'use client'

import { useEffect, useRef } from 'react'
import { motion, useAnimation, useInView } from 'framer-motion'

export function FadeIn({
  children,
  once = true,
  delay = 0,
  duration = 0.6,
  y = 16,
  x = 0,
  threshold = 0.15,
  className = '',
}: {
  children: React.ReactNode
  once?: boolean
  delay?: number
  duration?: number
  y?: number
  x?: number
  threshold?: number
  className?: string
}) {
  const ref = useRef(null)
  const inView = useInView(ref, { amount: threshold, once })
  const controls = useAnimation()

  useEffect(() => {
    if (inView) {
      controls.start({
        opacity: 1,
        x: 0,
        y: 0,
        transition: {
          delay,
          duration,
          ease: [0.22, 1, 0.36, 1], // easeOutExpo 效果
        },
      })
    }
  }, [inView, controls, delay, duration])

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x, y }}
      animate={controls}
      className={className}
    >
      {children}
    </motion.div>
  )
}


